var _a, _b;
import React from 'react';
import styled from 'styled-components';
import { Header } from '../components';
import { Wrapper } from '../styled';
const illustration404 = (_a = require('../media/Illustrations/illustration404.svg')) === null || _a === void 0 ? void 0 : _a.default;
const number404 = (_b = require('../media/Illustrations/404.svg')) === null || _b === void 0 ? void 0 : _b.default;
const Content = styled.div `
  display: flex;
  justify-content: center;
  padding: 56px 24px;
  margin-bottom: 64px;
  height: calc(100vh - 128px);
  max-width: 1440px;
  margin: auto;
  @media (min-width: 1024px) {
    padding: 56px 72px;
    justify-content: space-between;
  }
  @media (min-width: 1280px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
const IllustrationWrapper = styled.div `
  display: none;
  @media (min-width: 1024px) {
    width: 600px;
    display: block;
    margin: auto 0;
  }
`;
const Number404 = styled.img `
  width: 164px;
  height: 64px;
  align-self: center;
  margin-bottom: 32px;
  @media (min-width: 768px) {
    width: 276px;
    height: 108px;
  }
`;
const Wrapper404 = styled.div `
  max-width: 512px;
  a:focus {
    outline: 0;
  }
  a:hover {
    text-decoration: none;
    color: #fff;
  }
  @media (min-width: 1024px) {
    margin-right: 72px;
  }
`;
const Title = styled.div `
  font-size: 32px;
  font-weight: bold;
  line-height: 1.25;
  letter-spacing: -0.01px;
  color: #29333d;
  margin-bottom: 16px;
`;
const Description = styled.div `
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.04px;
  text-align: justify;
  color: #697d8e;
  margin-bottom: 12px;
`;
const LearnMore = styled.div `
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.04px;
  text-align: justify;
  color: #697d8e;
  margin-bottom: 16px;

  a {
    color: #006dff;
    text-decoration: underline;
  }
  a:hover {
    color: #006dff;
    text-decoration: underline;
  }
`;
const ContactTitle = styled.div `
  font-size: 16px;
  font-weight: bold;
  line-height: 1.38;
  letter-spacing: 0.04px;
  color: #29333d;
  margin-bottom: 7px;
`;
const ContactInfo = styled.div `
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.01px;
  margin-bottom: 24px;
  a {
    color: #29333d;
    text-decoration: none;
  }
  a:focus {
    outline: 0;
  }
  a:hover {
    text-decoration: none;
    color: #29333d;
  }
`;
const Button = styled.div `
  width: 100%;
  height: 48px;
  border-radius: 25px;
  background: #006dff;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.38;
  letter-spacing: 0.04px;
  text-align: center;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  @media (min-width: 1024px) {
    width: 233px;
  }
`;
const Box404 = ({ translations }) => {
    const { title, description, learnMore, contactTitle, buttonText } = translations;
    return (React.createElement(Wrapper, null,
        React.createElement(Header, null),
        React.createElement(Content, null,
            React.createElement(Wrapper404, null,
                React.createElement(Number404, { src: number404 }),
                React.createElement(Title, null, title),
                React.createElement(Description, null, description),
                React.createElement(LearnMore, null, learnMore),
                React.createElement(ContactTitle, null, contactTitle),
                React.createElement(ContactInfo, null,
                    React.createElement("a", { className: "phone-no", href: "tel:+48223975138" }, "+48 22 397 51 38"),
                    ' ',
                    "|",
                    ' ',
                    React.createElement("a", { className: "email", href: "mailto:support@autenti.com" }, "support@autenti.com")),
                React.createElement("a", { href: "https://autenti.com" },
                    React.createElement(Button, null, buttonText))),
            React.createElement(IllustrationWrapper, null,
                React.createElement("img", { src: illustration404 })))));
};
export default Box404;
